import * as React from 'react';
import { useSelector } from 'react-redux';
import SetPageTitle from 'components/Portals/SetPageTitle';
import { Routes, useTypedLocation } from 'routing';
import { useTranslation } from 'services/localization/useTranslation';

import * as UserSelectors from 'selectors/UserSelectors';

import GeneralTab from './Tabs/General';
import OpeningHoursTab from './Tabs/OpeningHours';
import OnlineStoreTab from './Tabs/OnlineStore';
import CheckInTab from './Tabs/CheckIn';
import EmailsTab from './Tabs/Emails';

import TabContainer, { TabContainerTabArgs } from 'components/nav/TabContainer';
import Container from 'components/Container';
import { useHasFeature } from 'hooks/useHasFeature';
import SetPageNavAction from 'components/Portals/SetPageNavAction';

export const ShopView = () => {
	const { t } = useTranslation();
	const { state } = useTypedLocation();

	const { hasFeature } = useHasFeature();

	const activeLocationId = useSelector(UserSelectors.userActiveLocationId);

	const tabs: TabContainerTabArgs[] = [
		{
			path: 'general',
			label: t('shop.general', 'General'),
			component: GeneralTab,
		},
		{
			path: 'opening-hours',
			label: t('shop.openingHours', 'Opening hours'),
			component: OpeningHoursTab,
		},
		{
			path: 'online-store',
			label: 'Online store',
			component: OnlineStoreTab,
		},
		{
			path: 'check-in',
			label: 'Check-in',
			component: CheckInTab,
			locked: !hasFeature('CHECK_IN', {
				scope: 'shop',
			}),
		},
		{
			path: 'emails',
			label: t('shop.emails', 'Emails'),
			component: EmailsTab,
		},
	];

	return (
		<React.Fragment key={activeLocationId}>
			<SetPageTitle title={t('store.storeSettings', 'Store settings')} />
			{state?.from === Routes.HOME_VIEW && (
				<SetPageNavAction
					priority={2}
					backAction={{
						to: Routes.HOME_VIEW,
						title: t('common:actions.home', 'Home'),
					}}
					quickLinks={[]}
				/>
			)}
			<Container>
				<TabContainer basePath={Routes.STORE} tabs={tabs} />
			</Container>
		</React.Fragment>
	);
};

export default ShopView;
